import { Toaster } from "@diverge/ui/ui/toast";

import { useDashboardTranslate } from "../../hooks/useDashboardTranslate";
import { translationNavigation } from "../../utils/translations";

export default function NotificationToaster() {
  const t = useDashboardTranslate(translationNavigation);
  return (
    <Toaster
      closeLabel={t("notificationClose")}
      // Above the upload page's own layers (up to 10000); the test chat widget
      // (999950) still covers it.
      viewportClassName="z-[99999]"
    />
  );
}
